import { render, staticRenderFns } from "./reactivo-categorizacion.vue?vue&type=template&id=f7b36540&scoped=true&"
import script from "./reactivo-categorizacion.vue?vue&type=script&lang=js&"
export * from "./reactivo-categorizacion.vue?vue&type=script&lang=js&"
import style0 from "./reactivo-categorizacion.vue?vue&type=style&index=0&id=f7b36540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b36540",
  null
  
)

export default component.exports